import React from 'react';

const TableHeading = ({accountHasSeparateBidReviews}) => {
    if (accountHasSeparateBidReviews) {
        return (
            <thead>
            <tr>
                <td className="bg-warning text-primary"></td>
                <td className="bg-warning text-primary"></td>
                <td colSpan={3} className="text-bold text-center">
                    {window.__js_bid_reviews.review_bids}
                </td>
                <td colSpan={4} className="bg-primary text-bold text-center">
                    {window.__js_bid_reviews.assignment_evaluation}
                </td>
            </tr>
            <tr>
                <th rowSpan={2} className="bg-warning text-primary">Α/Α</th>
                <th rowSpan={2} className="bg-warning text-primary">{window.__js_general.username}</th>
                <th>{window.__js_bid_reviews.documents_review}</th>
                <th>{window.__js_bid_reviews.technical_bid_review}</th>
                <th>{window.__js_bid_reviews.financial_bid_review}</th>
                <th className="bg-primary">{window.__js_general.enable}</th>
                <th className="bg-primary">{window.__js_general.status}</th>
                <th className="bg-primary">{window.__js_bid_reviews.rejection_reason}</th>
                <th className="bg-primary">{window.__js_bid_reviews.review_datetime}</th>
            </tr>
            </thead>
        );
    }

    return (
        <thead>
        <tr>
            <td className="bg-warning text-primary"></td>
            <td className="bg-warning text-primary"></td>
            <td></td>
            <td colSpan={4} className="bg-primary text-bold text-center">
                {window.__js_bid_reviews.assignment_evaluation}
            </td>
        </tr>
        <tr>
            <th rowSpan={2} className="bg-warning text-primary">Α/Α</th>
            <th rowSpan={2} className="bg-warning text-primary">{window.__js_general.username}</th>
            <th rowSpan={2}>{window.__js_bid_reviews.review_bids}</th>
            <th className="bg-primary">{window.__js_general.enable}</th>
            <th className="bg-primary">{window.__js_general.status}</th>
            <th className="bg-primary">{window.__js_bid_reviews.rejection_reason}</th>
            <th className="bg-primary">{window.__js_bid_reviews.review_datetime}</th>
        </tr>
        </thead>
    );
}

export default TableHeading;